export type Config = {
	API_URL: string;
	AES_KEY: number[];
};

export enum configKeys {
	API_URL = 'API_URL',
	AES_KEY = 'AES_KEY',
}
